/*
 * filename: table.js
 * Get the user data from store and show
 * */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import RaisedButton from 'material-ui/RaisedButton';
import { Field, reduxForm, reset } from 'redux-form';
import Highcharts from 'highcharts';
import Exporting from 'highcharts/modules/exporting';
import ExportingData from 'highcharts/modules/export-data';
import { renderAutoCompleteScheduling, renderCheckBox, renderDateField } from '../components/reduxFields';
import { getOrganizationFinancialKPIGraph } from '../modules/Dashboards/actions/StaffDashboardActions';
Exporting(Highcharts);
ExportingData(Highcharts);
/**
 * A simple table demonstrating the hierarchy of the `Table` component and its sub-components.
 */
class FinancialKPI_COLLECTIONRATE extends Component {

  constructor(props) {
    super(props);        
    this.state = {        
        xAxisDateOption: [],  
        isReset: false
      };    
  }

  // loadOrganizationBillableHoursGraph() {
  //   let searchObj3 = {
  //     contain_filters: {
  //       fromDate: this.state.FromFinancialDate ? moment(this.state.FromFinancialDate).format('YYYY-MM-DD') : new Date(),
  //       toDate: this.state.ToFinancialDate ? moment(this.state.ToFinancialDate).format('YYYY-MM-DD') : new Date(),
  //       payerIds: [],
  //       appointmentTypeIds: [],
  //       staffIds: [],
  //       patientIds: [],
  //       locationIds: [],
  //       //IsBillable: isBillable ? true : false, 
  //     }, 
  //   };
  //   this.props.getOrganizationFinancialKPIGraph(searchObj3);
  // }

  componentDidMount = () => {
    this.highchartsHandler();
  }

  componentDidUpdate = () => {
      if(this.props.financialDataAnalytics !== null) {
          this.highchartsHandler();
      }
  }

  handleReset = () => {
    this.props.dispatch(reset('FinancialKPI_COLLECTIONRATEForm'));    
    this.props.handleResetFinancialKPI();
  };

  highchartsHandler = () => {
    let finalData = [];
    let xAxisLabel = 'Open Balance';
    let yAxisLabel = 'Payment Status'; 

    if (this.props.financialDataAnalytics !== null && this.props.financialDataAnalytics.data != null && this.props.financialDataAnalytics.data.patientOrganizationFinancialKPIGraph != null  && this.props.financialDataAnalytics.data.patientOrganizationFinancialKPIGraph.length > 0) {
      this.props.financialDataAnalytics.data.patientOrganizationFinancialKPIGraph.map((obj, index) => {
                    let dataObj = {}
                    dataObj['name'] = obj.name;
                    dataObj['y'] = obj.y != null && obj.y < 0 ? Math.abs(obj.y) : obj.y;
                    //dataObj['y'] = obj.y;
                    finalData.push(dataObj);
                })
    }
    Highcharts.setOptions({
        lang: {
          thousandsSep: ','
        },
        colors: ['#058DC7', '#50B432', '#ED561B', '#DDDF00', '#24CBE5', '#64E572', '#FF9655', '#FFF263', '#6AF9C4']
    });

    Highcharts.chart('analyticsDataDivCollectionRate', {
        chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie'
        },
        title: {
            text: ''
        },

        yAxis: {
            title: {
            text: `<b>${xAxisLabel}</b>`
            }
        },

        legend: {
            layout: 'vertical',
            align: 'right',
            verticalAlign: 'middle',
            enabled: false
        },

        xAxis: {
            title: {
                text: `<b>${yAxisLabel}</b>`,
            },
            type: 'category'
        },

        tooltip: {
            enabled: false
        },

        credits: {
            enabled: false
        },

        plotOptions: {
            series: {
                cursor: 'pointer',
                borderWidth: 0,
                dataLabels: {
                    enabled: true
                },
                events: {
                    legendItemClick: function () {
                        return false
                    }
                },
                marker: {
                    enabled: true        
                }
            },
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                dataLabels: {
                    enabled: true,
                    format: '<b>{point.name}</b>: {point.percentage:.1f}% (${point.y:,.2f})'
                    //format: '<b>{point.name}</b>: ${point.y:.1f}',
                }
            }
            
        },

        series: [
            {
                colorByPoint: true,
                data: finalData
            }
        ],

        responsive: {
            rules: [{
                condition: {
                    maxWidth: 500
                },
                chartOptions: {
                    legend: {
                        layout: 'horizontal',
                        align: 'center',
                        verticalAlign: 'bottom'
                    }
                }
            }]
        },

        navigation: {
            buttonOptions: {
                verticalAlign: 'top',
                x: -100
            }
        },

        lang: {
            contextButtonTitle: 'Click to open'
        },

        exporting: {
            buttons: {
                contextButton: {
                    menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "downloadCSV", "downloadXLS"]
                }
            },
            chartOptions: {
                //colors: ['#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000', '#000000'],
            }
        }
    });
}
  

  render() {    
    //const { handleSubmit, OrganizationAuthorization } = this.props;
   // const authList =  (OrganizationAuthorization && OrganizationAuthorization.data) || []
    return (
      <div>
        <div className="row">
          <div className="col-sm-12">
                <form className="readmin-form custom_form" >                
                  <div className="row end-flex">         
                    <div className="col-sm-4 ml-10">
                      <Field name="FromFinancialDate"
                        placeholder="From Date"
                        locale="en-US"
                        selected={this.props.FromFinancialDate}
                        onDateChange={this.props.onFinancialKPIDateChange}
                        openToYearSelection={true}
                        component={renderDateField} />
                    </div>
                    <div className="col-sm-4 ml-10">
                      <Field name="ToFinancialDate"
                        placeholder="To Date"
                        locale="en-US"
                        minDate = {this.props.FromFinancialDate}
                        selected={this.props.ToFinancialDate}
                        openToYearSelection={true}
                        onDateChange={this.props.onFinancialKPIDateChange}
                        component={renderDateField} />
                    </div>                 
                    <div className="col-sm-4 ml-10 mt-35">
                      <Field name="financialPayerIds"
                        label="Payer"
                        handleNewRequest={this.props.handleFinancialChange}
                        options={this.props.masterInsuranceCompanies}
                        component={renderAutoCompleteScheduling}
                      />
                    </div>                       
                  </div>                       
                  <div className="row end-flex">                             
                    <div className="col-sm-4 ml-10 mt-35">
                      <Field
                        name="financialPatientIds"
                        label="Client"
                        handleNewRequest={this.props.handleFinancialChange}
                        options={this.props.patientlist}
                        component={renderAutoCompleteScheduling}
                        fullWidth={true}
                      />
                    </div>
                    <div className="col-sm-4 ml-10 mt-35">
                      <Field
                        name="financialLocationIds"
                        label="Location"
                        handleNewRequest={this.props.handleFinancialChange}
                        options={this.props.userLocationList}
                        component={renderAutoCompleteScheduling}
                        fullWidth={true}
                      />
                    </div>           
                    <div className="col-sm-4 mt-20">
                      <Field
                        className="mt20 mb0"
                        name="isExcludePR"
                        label="Exclude patient responsibility amount"
                        onChange={(e) => this.props.checkFinancialExcludePR(e)}
                        component={renderCheckBox}
                      />
                    </div>                                   
                    <div className="reset-btn col-sm-4 btn_rt">
                      <RaisedButton className="grey_btn ml_15" onTouchTap={this.handleReset}>Reset</RaisedButton>
                    </div>
                  </div>
              </form>    
          </div>
        </div>
        <div className='row'>            
            <div className='col-sm-11'>
              {
                  this.props.loading ? "Loading..." :
                  <div>                         
                      {this.state.xAxisDateOption.length > 0 ? 
                      <div className='row'>                          
                          <div className='col-sm-6'></div>
                      </div>   
                      : null}
                      <div id='analyticsDataDivCollectionRate' style={{ height: '500px' }} /> 
                  </div>
              }
            </div>
          </div>        
      </div>
    );
  }
}

FinancialKPI_COLLECTIONRATE = reduxForm({
  form: 'FinancialKPI_COLLECTIONRATEForm',
})(FinancialKPI_COLLECTIONRATE);

function mapStateToProps(state) {   
    //console.log('state.staff_dashboard2............',state.staff_dashboard)
  return {
    financialDataAnalytics: state.staff_dashboard ? state.staff_dashboard.OrganizationFinancialKPIGraph : {},    
    RightPanel_loading: state.staff_dashboard.RightPanel_loading,
  };
}

export default connect(mapStateToProps, { getOrganizationFinancialKPIGraph })(FinancialKPI_COLLECTIONRATE);



// WEBPACK FOOTER //
// ./src/adminCharts/FinancialKPI_COLLECTIONRATE.js